<template>
  <div>
    <SplitterComponent
      id="default-splitter"
      ref="_splitter"
    >
      <e-panes>
        <e-pane content="#middle-pane-content" />
      </e-panes>
    </SplitterComponent>

    <div
      id="middle-pane-content"
    >
      <ApiStatusBannerComponent />
      <router-view />
    </div>
    <div
      id="vehicle-registration-pane"
      style="display: none;"
    >
      <SideHeaderComponent @close="onClose(_vehicleRegistrationIndex)">
        Kfz-Zulassung
      </SideHeaderComponent>
      <VehicleRegistrationSideComponent />
    </div>
    <div
      id="insurance-pane"
      style="display: none;"
    >
      <SideHeaderComponent @close="onClose(0)">
        Versicherungskarte
      </SideHeaderComponent>
      <InsuranceSideComponent />
    </div>
  </div>
</template>

<script setup lang="ts">


import {
  PanesDirective as EPanes,
  PaneDirective as EPane,
  SplitterComponent
} from "@syncfusion/ej2-vue-layouts";
import {computed, ref, watch} from "vue";
import {useNavigationStore} from "@/modules/Navigation/store";
import {storeToRefs} from "pinia";
import InsuranceSideComponent from "@/modules/Insurance/components/InsuranceSideComponent.vue";
import SideHeaderComponent from "@/app/components/SideHeaderComponent.vue";
import ApiStatusBannerComponent from "@/app/components/ApiStatusBannerComponent.vue";
import VehicleRegistrationSideComponent
  from "@/modules/VehicleRegistration/components/VehicleRegistrationSideComponent.vue";
import {useDisplay} from 'vuetify'
import {useAccountStore} from "@/stores/accountStore";

interface Props {
  id?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    id: undefined
  }
)

const _splitter = ref<InstanceType<typeof SplitterComponent> | null>(null)

const _insuranceCreated = ref(false)
const _vehicleRegistrationCreated = ref(false)
const _navigationStore = useNavigationStore();
const _accountStore = useAccountStore()

const {currentInsuranceId, currentVehicleRegistrationId} = storeToRefs(_navigationStore)
const {mobile: _isMobile} = useDisplay()

const {isRoot} = storeToRefs(_accountStore)


const _vehicleRegistrationIndex = computed(() => {
  return _insuranceCreated.value ? 1 : 0;
})

function onClose(index: number) {
  _splitter.value.collapse(index)
}

watch(_isMobile, (value, oldValue) => {
  if (!oldValue && value) {
    if (_insuranceCreated.value) {
      _splitter.value.collapse(0)
    }
    if (_vehicleRegistrationCreated.value) {
      _splitter.value.collapse(_vehicleRegistrationIndex.value)
    }
  }
})

watch(currentInsuranceId, () => {
    if (_isMobile.value) {
      return;
    }
    if (!_splitter.value) {
      return
    }
    if (_insuranceCreated.value) {
      _splitter.value.expand(0)
    } else {
      _splitter.value.addPane({content: "#insurance-pane", size: '320px', min: "320px"}, 0)
      _insuranceCreated.value = true;
    }
  }
)

watch(currentVehicleRegistrationId, () => {
    if (_isMobile.value || !isRoot.value) {
      return;
    }
    if (!_splitter.value) {
      return
    }
    if (_vehicleRegistrationCreated.value) {
      _splitter.value.expand(_vehicleRegistrationIndex.value)
    } else {
      _splitter.value.addPane({
        content: "#vehicle-registration-pane",
        size: '400px',
        min: "350px"
      }, _vehicleRegistrationIndex.value)
      _vehicleRegistrationCreated.value = true;
    }
  }
)

</script>

<style scoped>

</style>
